
import './App.css';
import Header from './component/Header/Header';
import Body from './component/Body/Body';

function App() {
  return (
    <div >
      {/* Contents of Header are displayed here */}
      <Header />
      {/* Contents of Body are displayed here*/}
      <Body />

    </div>
  );
}

export default App;